import { DataStorage } from './enum/dataStorage';
import Contact from './models/contact';
import Deal from './models/deal';
import Document from './models/document';
import User from './models/user';
import UserSignData from './models/userSignData';

class BXRest {
    constructor() {
        this.domain = '';
        this.cache = {};
        this.resizeTimestamp = 0;
        this.scrollSize = {};
        this.initComplete = false;
        this.placementInformation = false;
        //this.local = !false;
    }

    appCache(key, value) {
        if (typeof value === 'undefined') {
            return this.cache[key];
        }
        this.cache[key] = value;
    }

    clearCacheDocument(id) {
        this.appCache(CacheType.KeyForDocument(id), null);
    }

    clearCacheUser(id) {
        this.appCache(CacheType.KeyForUser(id), null);
    }

    installComplete() {
        const BX24 = window.BX24 || false;
        if (!BX24)
            return;

        BX24.installFinish();
    }

    getDomain() {
        return this.domain;
    }

    getLang() {
        return this.lang === 'ru' ? 'ru' : 'en';
    }

    isInitComplete() {
        return this.initComplete;
    }

    getAuth() {
        const BX24 = window.BX24 || false;
        if (!BX24)
            return;
        return BX24.getAuth();
    }

    init() {
        const _ = this;
        return new Promise((resolve, reject) => {
            const BX24 = window.BX24 || false;
            if (BX24) {
                BX24.init(function () {
                    _.initComplete = true;
                    _.domain = BX24.getDomain();
                    _.lang = BX24.getLang();
                    _.placementInformation = BX24.placement.info();
                    //_.scrollSize = BX24.getScrollSize();
                    BX24.callMethod('user.current', {}, function (result) {
                        if (result.error()) {
                            console.error('error-get-current-user', result.error());
                            reject();
                        }
                        else {
                            const user = new User(result.data(), BX24.isAdmin());
                            //currApplication.loadCompanyStructure(callback);
                            resolve(user);
                        }
                    });
                });
            }
            else {
                reject();
            }
        })
    }

    resizeFrame() {
        const _ = this;
        const timestamp = new Date().getTime();
        this.resizeTimestamp = timestamp;
        setTimeout(function () {
            _.tryResize(timestamp);
        }, 300);
    }

    tryResize(timestamp) {
        const BX24 = window.BX24 || false;
        if (!BX24)
            return;
        const _ = this;
        if (_.resizeTimestamp === timestamp) {
            BX24.fitWindow();
        }
    }

    getUsers(ids) {
        const _ = this;
        return new Promise((resolve, reject) => {
            ids = ids.filter(x => x > 0);
            var arEntities = {};
            const arFind = [];
            ids.forEach((id) => {
                var entity = _.appCache(CacheType.KeyForUser(id));
                if (entity) {
                    arEntities[id] = entity;
                } else {
                    arFind.push(id);
                }
            });

            if (arFind.length < 1) {
                resolve(arEntities);
                return;
            }
            _.callMethod('user.get', { 'ID': arFind }, true).then((result) => {
                result.items.forEach(item => {
                    const entity = new User(item, Rest.getDomain());
                    _.appCache(CacheType.KeyForUser(entity.Id), entity);
                    arEntities[entity.Id] = entity;
                });
                resolve(arEntities);
            }).catch(err => {
                reject(err);
            });
        });
    }

    getDealFiles(ids) {
        const _ = this;
        return new Promise((resolve, reject) => {
            ids = ids.filter(x => x > 0);
            var arEntities = {};
            if (ids.length < 1) {
                resolve(arEntities);
                return;
            }
            this.callMethod('crm.documentgenerator.document.list', {
                filter: {
                    id: ids
                }
            }, true).then((result) => {
                result.items.forEach(item => {
                    arEntities[item.id] = item;
                });
                resolve(arEntities);
            }).catch(err => {
                console.error('', err);
                resolve(arEntities);
            });
        })
    }

    getDeals(ids) {
        const _ = this;
        return new Promise((resolve, reject) => {
            ids = ids.filter(x => x > 0);
            var arEntities = {};
            if (ids.length < 1) {
                resolve(arEntities);
                return;
            }
            this.callMethod('crm.deal.list', {
                filter: {
                    ID: ids
                }
            }, true).then((result) => {
                result.items.forEach(item => {
                    const entity = new Deal(item, Rest.getDomain());
                    arEntities[entity.Id] = entity;
                });
                resolve(arEntities);
            }).catch(err => {
                console.error('', err);
                resolve(arEntities);
            });
        });
    }

    getContacts(ids) {
        const _ = this;
        return new Promise((resolve, reject) => {
            ids = [...new Set(ids.filter(x => x > 0))];
            var arEntities = {};
            if (ids.length < 1) {
                resolve(arEntities);
                return;
            }
            this.callMethod('crm.contact.list', {
                select: ['*', 'EMAIL', 'PHONE', 'IM'],
                filter: {
                    ID: ids
                }
            }, true).then((result) => {
                result.items.forEach(item => {
                    const entity = new Contact(item, Rest.getDomain());
                    arEntities[entity.Id] = entity;
                });
                resolve(arEntities);
            }).catch(err => {
                console.error('getContacts', err);
                resolve(arEntities);
            });
        });
    }

    getDocuments(ids) {
        const _ = this;
        return new Promise((resolve, reject) => {
            ids = ids.filter(x => x > 0);
            var arEntities = {};
            const arFind = [];
            ids.forEach((id) => {
                const entity = _.appCache(CacheType.KeyForDocument(id));
                if (entity) {
                    arEntities[id] = entity;
                } else {
                    arFind.push(id);
                }
            });

            if (arFind.length < 1) {
                resolve(arEntities);
                return;
            }

            this.callMethod('entity.item.get', {
                ENTITY: DataStorage.document,
                //SORT: { DATE_ACTIVE_FROM: 'ASC', ID: 'ASC' },
                FILTER: {
                    ID: arFind
                }
            }, true).then((result) => {
                result.items.forEach(item => {
                    const entity = new Document(item, Rest.getDomain());
                    //_.appCache(CacheType.KeyForDocument(entity.Id), entity);
                    arEntities[entity.Id] = entity;
                });
                resolve(arEntities);
            });
        });
    }

    async getUserSignData(userId) {
        const result = await Rest.callMethod('entity.item.get', {
            ENTITY: DataStorage.user, filter: {
                PROPERTY_USER: userId
            }
        });
        return result.items.length > 0 ? new UserSignData(result.items[0]) : null;
    }

    callBatch(batchData, callback) {
        const BX24 = window.BX24 || false;
        if (!BX24)
            return;
        BX24.callBatch(batchData, function (result) {
            callback(result);
        });
    }

    callBatchAsync(batchData) {
        return new Promise((resolve, reject) => {
            const BX24 = window.BX24 || false;
            if (!BX24) {
                reject();
                return;
            }

            BX24.callBatch(batchData, function (result) {
                resolve(result);
            });
        })
    }

    prepareResult(items, data) {
        if (Array.isArray(data)) {
            data.forEach((item) => {
                items.push(item);
            });
            return;
        }
        if (data.documents && Array.isArray(data.documents)) {
            data.documents.forEach((item) => {
                items.push(item);
            });
            return;
        }
        items.push(data);
    }

    callMethod(method, requestData = {}, all = false) {
        const _ = this;
        return new Promise((resolve, reject) => {
            const BX24 = window.BX24 || false;
            if (!BX24) {
                reject();
                return;
            }
            const items = [];
            BX24.callMethod(method, requestData, (result) => {
                if (result.error()) {
                    reject(result.error());
                }
                else {
                    const data = result.data();
                    _.prepareResult(items, data);
                    if (!all) {
                        resolve({ items: items, total: result.total() });
                    }
                    else {
                        if (result.more()) {
                            result.next();
                        }
                        else {
                            resolve({ items: items });
                        }
                    }
                }
            });
        })
    }

    scrollParentWindow(offset = 0) {
        const BX24 = window.BX24 || false;
        if (!BX24) {
            return;
        }
        BX24.scrollParentWindow(offset);
    }

    placementInfo() {
        return this.placementInformation;
    }

    removePlacementOption(key) {//todo
        delete this.placementInformation.options[key];
    }
}

class CacheType {
    static KeyForUser(id) {
        return `User_${id}`;
    }

    static KeyForDocument(id) {
        return `Document_${id}`;
    }
}

export const Rest = new BXRest();